import { render } from "./StatisticPage.vue?vue&type=template&id=25d4d930&scoped=true"
import script from "./StatisticPage.vue?vue&type=script&lang=js"
export * from "./StatisticPage.vue?vue&type=script&lang=js"

import "./StatisticPage.vue?vue&type=style&index=0&id=25d4d930&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-25d4d930"]])

export default __exports__